var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ACACAC",
  fillRule: "evenodd",
  d: "M3.434 4.5.217 1.283.782.717 4 3.934 7.217.717l.565.566L4.565 4.5l3.217 3.217-.565.566L4 5.066.782 8.283l-.565-.566z",
  clipRule: "evenodd"
})));
export default SvgIconClose02;